<template>
  <div>
    <HeroSection :value="assessmentPage.hero_section">
      <template v-if="assessmentPage.hero_section.cta" #cta>
        <HeroCta :value="assessmentPage.hero_section.cta" />
      </template>
    </HeroSection>
  </div>

  <EmbedSection
    :value="assessmentPage.embed_section"
    class="mb-16 hero-section hero-below-offset"
  />
</template>

<script setup>
defineProps({
  assessmentPage: {
    required: true,
    type: Object
  }
})
</script>
